// tslint:disable
export enum CampaignResolutionType {
    /**
     * @description UNKNOWN
     */
    UNKN = 10001,
    /**
     * @description RE ATTEMPT
     */
    REAT = 10002,
    /**
     * @description REMOVE
     */
    RMV = 10003,
    /**
     * @description VERIFIED
     */
    VER = 10004,
    /**
     * @description DENIED
     */
    DEN = 10005,
    /**
     * @description NO CONTACT
     */
    NOC = 10006,
    /**
     * @description PHONE NOT FOUND
     */
    PHN = 10007,
    /**
     * @description FOLLOWUP
     */
    FLUP = 10008,
}
